import { register, pause, play } from '../../services/players'

import Utils from 'nova-tn-frontend/source/scripts/modules/Utils'

const events = {
	data() {
		return {
			events: null,
		}
	},
	created() {
		const create = () => {
			register((data = {}) => {
				const videoId = data?.customData?.videoID
				const short = data?.customData?.embed?.short

				if (!videoId) {
					return
				}
				const eventName = data?.eventName

				if (
					window.Miniplayer?.playerId === this.currentVideoId &&
					['enterfullscreen', 'exitfullscreen'].includes(eventName)
				) {
					eventName == 'enterfullscreen'
						? this.mobile.goToFullscreen()
						: this.mobile.leaveFullscreen()
				}

				if (this.currentVideoId === short) {
					switch (eventName) {
						case 'ready':
						case 'init':
							this.events.handlers.readyInitEvent(data)
							this.dataslayer.push('play', data)
							this.dataslayer.updateMeasurementData(data)
							if (eventName === 'init') {
								this.isPlaying = true
							}
							break
						case 'play':
							this.isPlaying = true
							if (this.homepageTnLiveBox.length > 0) {
								this.events.handlers.playEvent()
							}
							break
						case 'ended':
							if (
								!data?.eventData.type ||
								data?.eventData?.type !== 'adend'
							) {
								this.events.handlers.endedEvent(data)
							}
							break
						case 'pause':
							this.isPlaying = false
							break
						case 'exitfullscreen':
							if (
								Utils.parentIsInFullscreen() &&
								document.fullscreenElement
							) {
								document.exitFullscreen()
							}
							break
						case 'recurring':
							this.dataslayer.updateMeasurementData(data)
							break
					}
				} else if (this.homepageTnLiveShort === short) {
					this.homepageTnLiveId = videoId
					if (eventName === 'play') {
						this.events.handlers.playEvent(true)
					}
				} else {
					switch (eventName) {
						case 'play':
						case 'init':
							if (this.isPlaying) {
								this.wasPlayingBefore = true
							}
							break
						case 'exitfullscreen':
							if (
								Utils.parentIsInFullscreen() &&
								document.fullscreenElement
							) {
								document.exitFullscreen()
							}
							break
						case 'pause':
						case 'ended':
							if (
								data.eventData?.initiator === 'user' &&
								this.wasPlayingBefore
							) {
								this.play()
							}
							break
					}
				}
			})
		}
		const readyInitEvent = (data) => {
			if (!data?.customData) {
				return
			}

			this.playerId = data.customData.videoID
			this.fullDescription = data.customData.video.title
		}
		const endedEvent = () => {
			this.shiftPosition()
			this.setSource(this.currentVideoId)
			this.fullDescription = ''
		}
		const playEvent = (isTnLivePlayer) => {
			isTnLivePlayer ? pause(this.playerId) : play(this.playerId)
		}
		const wrapOnClick = (e) => {
			// This means control button was clicked

			if (e.target !== e.currentTarget) {
				return
			}

			if ($(e.target).hasClass('icon')) {
				return
			}

			if (!this.isFullscreen) {
				this.mobile.enableFullscreen()
			}
		}
		const playPauseButtonOnClick = () => {
			this.isPlaying ? pause(this.playerId) : play(this.playerId)
		}
		const offButtonOnClick = () => {
			if (this.isFullscreen) {
				this.mobile.disableFullscreen()
			} else {
				this.mobile.hide()
				this.dataslayer.push('close', this.measurementData)
			}
		}
		const onButtonOnClick = () => {
			this.mobile.show()
			this.dataslayer.push('open', this.measurementData)
		}

		this.events = {
			create,
			handlers: {
				readyInitEvent,
				endedEvent,
				playEvent,
				wrapOnClick,
				playPauseButtonOnClick,
				offButtonOnClick,
				onButtonOnClick,
			},
		}
	},
}

export default events
